import {FacePart} from "../../common";

export default new FacePart({
	render () {
		return `
			<g transform="translate(0.000000, 8.000000)" fill-opacity="0.599999964">
				<path
					d="M16.1601674,32.4473116 C18.006676,28.648508 22.1644225,26 26.9975803,26 C31.8136766,26 35.9591217,28.629842 37.8153518,32.4071242 C38.3667605,33.5291977 37.5821037,34.4474817 36.790607,33.7670228 C34.3395063,31.6597833 30.8587163,30.3437884 26.9975803,30.3437884 C23.2572061,30.3437884 19.8737584,31.5787519 17.4375392,33.5716412 C16.5467928,34.3002944 15.6201012,33.5583844 16.1601674,32.4473116 Z"
					transform="translate(27.000000, 30.000000) scale(1, -1) translate(-27.000000, -30.000000) "/>
				<path
					d="M74.1601674,32.4473116 C76.006676,28.648508 80.1644225,26 84.9975803,26 C89.8136766,26 93.9591217,28.629842 95.8153518,32.4071242 C96.3667605,33.5291977 95.5821037,34.4474817 94.790607,33.7670228 C92.3395063,31.6597833 88.8587163,30.3437884 84.9975803,30.3437884 C81.2572061,30.3437884 77.8737584,31.5787519 75.4375392,33.5716412 C74.5467928,34.3002944 73.6201012,33.5583844 74.1601674,32.4473116 Z"
					transform="translate(85.000000, 30.000000) scale(1, -1) translate(-85.000000, -30.000000) "/>
			</g>
		`;
	},
});



// WEBPACK FOOTER //
// ./src/face/eyes/close.js